module.exports = __webpack_public_path__ + "assets/img/404.181eed3a.svg";